import { useSelector } from 'react-redux';
import { IStoreOrganization } from 'store/types';

export default function useOrganization() {
  return useSelector((state: { organization: IStoreOrganization }) => state.organization);
}
